import React from 'react';

import { AboutContainer, AboutImages, AboutText, MainImage, MiniImage } from './AboutStyles';
import Cta from 'src/components/Cta';
import { Arrow } from 'src/styles/DesignSystem';
import pattern from 'src/assets/pattern-about.png';

import { useNavigate } from 'react-router-dom';


const About = ({ about, mainImage, img01, img02, img03 }) => {

    const linkto = useNavigate();

    const toInstitucional = () =>{
        linkto('/institucional');
    }

    return (
        <AboutContainer>
            <img src={pattern} alt="  " />

            <AboutImages>
                <MainImage>
                    <img src={mainImage} alt="Hipermercado das rações" />
                </MainImage>

                <MiniImage src={img01} alt="Hipermercado das rações" />
                <MiniImage src={img02} alt="Hipermercado das rações" />
                <MiniImage src={img03} alt="Hipermercado das rações" />
                
            </AboutImages>

            <AboutText>
                <h2>O Hipermercado</h2>
                <p dangerouslySetInnerHTML={{__html: about}} />

                <Cta onclick={toInstitucional}>
                    Saiba mais
                    <Arrow />
                </Cta>
            </AboutText>
        </AboutContainer>
    )
}

export default About